import React, { FC } from 'react';
import Icon from '@ant-design/icons';
import { IconProps } from 'ui/components/Icon';

const CheckSVG = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.5358 7.47517C19.8256 7.77106 19.8207 8.24591 19.5248 8.53577L10.3373 17.5358C10.0457 17.8214 9.57926 17.8214 9.28766 17.5358L4.47517 12.8215C4.17927 12.5316 4.17437 12.0568 4.46423 11.7609C4.75409 11.465 5.22894 11.4601 5.52484 11.7499L9.8125 15.9501L18.4752 7.46423C18.7711 7.17437 19.2459 7.17927 19.5358 7.47517Z'
      fill='currentColor'
    />
  </svg>
);

export const Check1Outline: FC<IconProps> = props => <Icon component={CheckSVG} {...props} />;
